import React from 'react';
import './About.css';
import AboutSarah from '../assets/img/about-sarah.webp';
import { Seo, buildBreadcrumbSchema } from '../components/Seo';

function About() {
    return (
        <div className='about-page'>
            <Seo
                title='Über uns'
                description='Erfahren Sie mehr über Sarita&apos;s in Hinwil, die Geschichte hinter dem Cafe und das Team rund um Sarah Ehrismann.'
                path='/about'
                schema={[
                    buildBreadcrumbSchema([
                        { name: 'Startseite', path: '/' },
                        { name: 'Über uns', path: '/about' }
                    ])
                ]}
            />
            <header className='page-hero about-hero'>
                <div className='container page-hero__content'>
                    <h1 className='page-hero__title'>Über uns</h1>
                </div>
            </header>

            <section className='section-shell'>
                <div className='container'>
                    <div className='about-intro panel-surface'>
                        <div className='about-intro__copy'>
                            <p className='section-eyebrow'>Wer wir sind</p>
                            <h2 className='section-title'>Sarita’s – Genuss zum Verweilen</h2>                            
                            <p>
                              Am Bahnhof Hinwil entstand im Frühling 2026 eine kleine Oase des Genusses: das Sarita’s. Seit April lädt das Café dazu ein, dem Alltag für einen Moment zu entfliehen, durchzuatmen und bewusst zu geniessen.
                            </p>
                            <p>
                              Hinter dem Sarita’s steht Inhaberin Sarah Ehrismann, Geschäftsleiterin, kreativer Kopf mit einer grossen Leidenschaft für Süssgebäck. Schon während ihrer Studienzeit träumte sie davon, ein eigenes Café zu eröffnen. Über Jahre hinweg entwickelte sie ihr Konzept weiter, probierte neue Ideen aus und liess Familie und Freunde unzählige Kreationen degustieren. Eine Spezialität im Sarita’s sind hausgemachte Cheesecakes in immer neuen Variationen, von klassisch über fruchtig und schokoladig bis hin zu vegan.
                            </p>
                            <p>
                             Doch auch andere hausgemachte Leckereien gehören zum festen Angebot: duftende Zimtschnecken, feine Quiches oder Penne mit selbstgemachter Pesto sorgen dafür, dass sowohl Süssliebhaber als auch Fans herzhafter Küche auf ihre Kosten kommen.
                            </p>
                            <p>
                              Unterstützt wird Sarah von ihrem Partner Manuel, der sich mit viel Engagement um alle technischen Belange kümmert, von der Gestaltung der Website bis zur Programmierung der Kasse. Auch die Familie steht mit Rat und Tat zur Seite. Im Service sorgt Stephanie mit ihrer offenen, energiegeladenen Art täglich dafür, dass sich die Gäste willkommen fühlen und gerne wiederkommen.
                            </p>
                            <p>
                              Im Sarita’s wird täglich frisch gekocht und gebacken, wann immer möglich mit saisonalen und regionalen Zutaten. So überrascht das Angebot immer wieder mit neuen Nuancen. Mal überrascht ein exotischer Cheesecake, mal eine besonders herbstliche Suppe oder ein sommerlich leichter Lunch. Eine liebevolle Konstante bleibt jedoch die hausgemachte Praline zum Kaffee. Ergänzt wird das Angebot durch eine Auswahl an offenen Tees, die auch in der Kanne für gesellige Runden serviert werden.
                            </p>
                            <p>
                              Das Motto «Genuss zum Verweilen» ist im Sarita’s Programm. Hier darf man sich Zeit nehmen für ein gutes Gespräch, eine spannende Lektüre oder einfach einen ruhigen Moment. Morgens oder über Mittag darf es aber auch einmal schnell gehen. Viele Getränke und Speisen können bequem zum Mitnehmen bestellt werden.
                            </p>
                            <p>
                              Sarita’s soll ein Ort sein, an dem Begegnungen entstehen, Bekanntschaften gepflegt werden und Gäste für eine Weile den Alltag hinter sich lassen können. Ein kleiner Gegenpol zur stetigen Beschleunigung unserer Zeit, mitten am Bahnhof Hinwil.
                            </p>
                        </div>
                        <div className='about-intro__images'>
                            <img src={AboutSarah} alt='Sarah Ehrismann im Sarita&apos;s' />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About;
